import { z } from 'zod';

import { apiCall } from './api';
import {
  ParentProfileResponseSchema,
  type AddChildInput,
  type ParentProfileResponse,
  type UpdateChildInput,
  type UpdateParentProfileInput,
} from './schemas/parent-profile';

const ShortlistResponseSchema = z.object({
  shortlistedTutorIds: z.array(z.string()),
});
export type ShortlistResponse = z.infer<typeof ShortlistResponseSchema>;

export async function fetchMyParentProfile(
  accessToken: string,
): Promise<ParentProfileResponse> {
  const res = await apiCall<unknown>('/parents/me', { accessToken });
  try {
    return ParentProfileResponseSchema.parse(res.data);
  } catch (err) {
    console.error('[parent-api] Schema parse error:', err);
    console.error('[parent-api] API response data:', res.data);
    throw err;
  }
}

export async function patchMyParentProfile(
  accessToken: string,
  body: UpdateParentProfileInput,
): Promise<ParentProfileResponse> {
  const res = await apiCall<unknown>('/parents/me', {
    method: 'PATCH',
    accessToken,
    body,
  });
  return ParentProfileResponseSchema.parse(res.data);
}

export async function addChild(
  accessToken: string,
  body: AddChildInput,
): Promise<ParentProfileResponse> {
  const res = await apiCall<unknown>('/parents/me/children', {
    method: 'POST',
    accessToken,
    body,
  });
  return ParentProfileResponseSchema.parse(res.data);
}

export async function updateChild(
  accessToken: string,
  childId: string,
  body: UpdateChildInput,
): Promise<ParentProfileResponse> {
  const res = await apiCall<unknown>(`/parents/me/children/${childId}`, {
    method: 'PATCH',
    accessToken,
    body,
  });
  return ParentProfileResponseSchema.parse(res.data);
}

export async function removeChild(
  accessToken: string,
  childId: string,
): Promise<void> {
  await apiCall<void>(`/parents/me/children/${childId}`, {
    method: 'DELETE',
    accessToken,
  });
}

export async function fetchShortlist(
  accessToken: string,
): Promise<ShortlistResponse> {
  const res = await apiCall<unknown>('/parents/me/shortlist', { accessToken });
  return ShortlistResponseSchema.parse(res.data);
}

export async function addToShortlist(
  accessToken: string,
  tutorId: string,
): Promise<ParentProfileResponse> {
  const res = await apiCall<unknown>('/parents/me/shortlist', {
    method: 'POST',
    accessToken,
    body: { tutorId },
  });
  return ParentProfileResponseSchema.parse(res.data);
}

export async function removeFromShortlist(
  accessToken: string,
  tutorId: string,
): Promise<void> {
  await apiCall<void>(`/parents/me/shortlist/${tutorId}`, {
    method: 'DELETE',
    accessToken,
  });
}
